module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_0.e89604ee.png";